module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Timer-5988a5666a5fcef6aa5b0bfd97d48e62.svg";